import { render } from "./NonUserWrapper.vue?vue&type=template&id=0f1195b1&ts=true"
import script from "./NonUserWrapper.vue?vue&type=script&lang=ts"
export * from "./NonUserWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/kochi-bus/photo_admin_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__